declare var ga: any;

export function track_google_analytics_event(name: string, status: string, callback: any) {

  if (typeof ga == "undefined") {
    console.log('analytics not found');
    if (callback) {
      callback();
    }

    return;
  }

  let callbackTriggered = false;
  let timeout: any = null;

  if (callback) {
    timeout = setTimeout(function () {
      callbackTriggered = true;
      callback();
    }, 5000);
  }

  const trackerName = ga.getAll()[0].get('name');
  ga(trackerName + '.send', 'event', name, status, {
    'page': window.location && window.location.pathname ? window.location.pathname : null,
    'hitCallback': function () {

      if (callback) {
        if (timeout) {
          clearTimeout(timeout);
        }

        if (!callbackTriggered) {
          callback();
        }
      }
    }
  });
}